import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/functions";
// import "firebase/database";
import "firebase/storage";

import {
  FIREBASE_API_KEY,
  FIREBASE_PROJECT_ID,
  FIREBASE_AUTH_DOMAIN,
  FIREBASE_STORAGE_BUCKET,
} from "./constants";

export const baseFirebaseApp = firebase.initializeApp({
  apiKey: FIREBASE_API_KEY,
  projectId: FIREBASE_PROJECT_ID,
  authDomain: FIREBASE_AUTH_DOMAIN,
  storageBucket: FIREBASE_STORAGE_BUCKET,
});

export class Firebase {
  constructor(firebaseApp) {
    // Initialize Firebase
    this.app = firebaseApp;

    this.auth = this.app.auth();
    this.functions = this.app.functions();
    this.storage = this.app.storage();
    this.bucket = this.storage.ref();
  }

  get currentUser() {
    return this.auth.currentUser;
  }

  getBucket() {
    return this.bucket.child(`statics`);
  }

  /* AUTH API */
  signInWithEmailAndPassword(email, password) {
    return this.auth.signInWithEmailAndPassword(email, password);
  }

  async setPersistence(remember = false) {
    try {
      await this.auth.setPersistence(
        remember
          ? firebase.auth.Auth.Persistence.LOCAL
          : firebase.auth.Auth.Persistence.SESSION
      );
    } catch (error) {
      await this.signOut();
      console.error(error);
    }
  }

  onAuthStateChanged(fn) {
    return this.auth.onAuthStateChanged(fn);
  }

  signOut() {
    return this.auth.signOut();
  }

  getFn(functionName) {
    return this.functions.httpsCallable(functionName);
  }
}

export default Firebase;
